export default "__VITE_ASSET__64b6b2bd__"